import React from "react";

import { FormInputComponent } from "../../../../shared/components/FormElements/GenericForm";

const CarouselStandCardEdition = (props) => {
    return (
        <React.Fragment>
            <div className={`generic-form__input-block`}>
                <label>Imagen</label>
                <input
                    multiple={true}
                    type="file"
                    name={`cards.${props.index}.imageArray`}
                    className="generic-form__form-input generic-form__form-input--file-upload generic-form__form-input--inline"
                    onChange={(event) => {
                        props.setFieldValue(
                            `cards.${props.index}.imageArray`,
                            event.currentTarget.files
                        );
                    }}
                />
            </div>
            <FormInputComponent
                fieldType="text"
                fieldName={`cards.${props.index}.description`}
                fieldDescription="Botones (separados por punto y coma)"
                fieldPlaceholder=""
            />
        </React.Fragment>
    );
};

export default CarouselStandCardEdition;
